import React from 'react';

const JSON_JSONP = () => {
  return (
    <div >
      <h1>JSON_JSONP</h1>
      <p>Placeholder component for: "JSON JSONP"</p>
    </div>
  );
};

export default JSON_JSONP;
